var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7399 9.15429C11.3653 8.84014 9.16843 7.449 8.80329 7.51286C8.63186 7.54329 8.50071 7.68943 8.14971 8.10814C7.98739 8.31424 7.80913 8.50726 7.61657 8.68543C7.26376 8.6002 6.92226 8.47361 6.59914 8.30829C5.33198 7.69136 4.30827 6.66735 3.69171 5.4C3.52639 5.07689 3.3998 4.73538 3.31457 4.38257C3.49274 4.19001 3.68576 4.01175 3.89186 3.84943C4.31014 3.49843 4.45671 3.36814 4.48714 3.19586C4.551 2.82986 3.15857 0.633857 2.84571 0.259286C2.71457 0.104143 2.59543 0 2.44286 0C2.00057 0 0 2.47371 0 2.79429C0 2.82043 0.0428571 5.39571 3.29529 8.70471C6.60429 11.9571 9.17957 12 9.20571 12C9.52629 12 12 9.99943 12 9.55714C12 9.40457 11.8959 9.28543 11.7399 9.15429ZM9 5.57143H9.85714C9.85612 4.66243 9.49457 3.79095 8.85181 3.14819C8.20905 2.50543 7.33757 2.14388 6.42857 2.14286V3C7.11035 3.00068 7.76401 3.27182 8.24609 3.75391C8.72818 4.23599 8.99932 4.88965 9 5.57143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.143 5.57143H12.0001C11.9984 4.09432 11.4109 2.67819 10.3664 1.63371C9.32195 0.589236 7.90582 0.00170142 6.42871 0V0.857143C7.67856 0.858617 8.87681 1.35577 9.76059 2.23955C10.6444 3.12333 11.1415 4.32158 11.143 5.57143Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.f72dba24a7e053f122dd61cd0ca25180.svg";
export { ForwardRef as ReactComponent };